module.exports = __webpack_public_path__ + "assets/sendman.c8653ec7.svg";